const simpleAction = (action, text) => {
    return {
        type: action,
        payload: text
    }
}

export {simpleAction};